<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="term3">
      <div class="term3-top">
        <div class="term3-top-info">
          联系人:
          <el-input
            v-model="name"
            disabled
            placeholder=""
            @input="handleName(name)"
          />
        </div>
        <div class="term3-top-info">
          联系电话:
          <el-input
            v-model="phone"
            disabled
            placeholder=""
            maxlength="11"
            @input="handleNumber(phone)"
          />
        </div>
        <span @click="handlePre">上一章</span>
        <span @click="handleNext">下一章</span>
        <span @click="handleSave">保存</span>
        <span>获取上年数据</span>
        <span @click="handleClear">清空</span>
      </div>
      <div class="term3-content">
        <el-table
          :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
          :data="data"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column prop="code" label="代码" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column width="320" prop="name" label="指标名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <el-tooltip
                v-if="scope.row.desc && scope.row.desc != ' '"
                effect="light"
                placement="left"
              >
                <div slot="content">
                  {{ scope.row.desc }}
                </div>
                <svg
                  t="1647934656452"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3085"
                  width="16"
                  height="16"
                  @click="handleOpen(scope.row.desc)"
                >
                  <path
                    d="M512 149.333333A362.666667 362.666667 0 1 1 149.333333 512 363.093333 363.093333 0 0 1 512 149.333333M512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A426.666667 426.666667 0 0 0 512 85.333333z"
                    fill="#2f82ff"
                    p-id="3086"
                  />
                  <path
                    d="M469.333333 672a31.573333 31.573333 0 0 1-22.613333-9.386667l-128-128a32 32 0 0 1 45.226667-45.226666L469.333333 594.773333l213.333334-213.333333A32 32 0 0 1 725.333333 426.666667l-234.666666 234.666666a31.573333 31.573333 0 0 1-21.333334 10.666667z"
                    fill="#2f82ff"
                    p-id="3087"
                  />
                </svg>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="uom" label="单位" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.uom }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value5" label="本年数值">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 421">
                <span class="text-center">{{ sum ? sum : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 422">
                <span class="text-center">{{ fuzhu ? fuzhu : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 43">
                <span class="text-center">{{ sheshi ? sheshi : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 431">
                <span class="text-center">{{ yiqi_yuanzhi ? yiqi_yuanzhi : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 432">
                <span class="text-center">{{ equip_yuanzhi ? equip_yuanzhi : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 433">
                <span class="text-center">{{ equip_price ? equip_price : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 43301">
                <span class="text-center">{{ ytm_price ? ytm_price : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 44">
                <span class="text-center">{{ jf_sum ? jf_sum : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 451">
                <span class="text-center">{{ gym ? gym : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 452">
                <span class="text-center">—</span>
              </section>
              <section
                v-else-if="scope.row.equipstandardopt.viewOnly[4] == false"
              >
                <el-select
                  v-if="scope.row.equipstandardopt.optional"
                  v-model="scope.row.value5"
                  placeholder="请选择"
                  @change="
                    handleValue(scope.row.value5, scope.$index, scope.row)
                  "
                >
                  <el-option
                    v-for="item in scope.row.equipstandardopt.optional"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="scope.row.value5"
                  :disabled="
                    scope.row.equipstandardopt.readOnly[4] == true
                      ? true
                      : false
                  "
                  placeholder=""
                  @input="handleNumber(scope.row.value5)"
                  @change="
                    handleValue(
                      scope.row.value5,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                />
              </section>
              <section v-else>
                <span class="text-center">—</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="value6" label="本年面积">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 421">
                <span class="text-center">{{ room_sum_area ? room_sum_area : scope.row.value6 }}</span>
              </section>
              <section v-else-if="scope.row.code == 422">
                <span class="text-center">{{ fuzhu_area ? fuzhu_area : scope.row.value6 }}</span>
              </section>
              <section v-else-if="scope.row.code == 451">
                <span class="text-center">{{ gym_area ? gym_area : scope.row.value6 }}</span>
              </section>
              <section v-else-if="scope.row.code == 452">
                <span class="text-center">{{ gym_averag ? gym_averag : scope.row.value6 }}</span>
              </section>
              <section v-else>
                <el-input
                  v-if="scope.row.equipstandardopt.viewOnly[5] == false"
                  v-model="scope.row.value6"
                  :disabled="
                    scope.row.equipstandardopt.readOnly[5] == true
                      ? true
                      : false
                  "
                  placeholder=""
                  @input="handleNumber(scope.row.value6)"
                  @change="
                    handleValue0(
                      scope.row.value6,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                />
                <span v-else class="text-center">—</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="logic" label="取值逻辑">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.logic"
                effect="light"
                placement="top">
                <div slot="content">
                  {{ scope.row.logic }}
                </div>
                <span class="logic" @click="handleOpen(scope.row.logic)">{{
                  scope.row.logic
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>
<script>
import api from '@/api/app'
import mock from '@/utils/mock'
export default {
  name: 'ComTerm3',
  components: {},
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      name: '',
      phone: '',
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      t: null,
      form: [],
      jsonForm: {},
      sum: null,
      room_sum_area: null,
      fuzhu: null,
      fuzhu_area: null,
      sheshi: null,
      yiqi_yuanzhi: null,
      equip_yuanzhi: null,
      equip_price: null,
      ytm_price: null,
      jf_sum: null,
      gym: null,
      gym_area: null,
      gym_averag: null,
      other: {
        num1: null,
        num2: null,
        num3: null,
        num4: null
      },
      pushArr: true
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.handleOthers()
    if (localStorage.getItem('form4')) {
      this.form = JSON.parse(localStorage.getItem('form4'))
    } else {
      this.form = this.data
    }
  },
  methods: {
    handleOthers() {
      var a = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num1,
        41,
        177,
        '4.1 教学仪器设备配备达标情况',
        '',
        '',
        {
          code: 41,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 177,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var b = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num2,
        42,
        185,
        '4.2 音体美卫功能教室配备情况',
        '',
        '',
        {
          code: 42,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 185,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var c = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num3,
        45,
        219,
        '4.5 体育场地建设情况',
        '',
        '',
        {
          code: 45,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 219,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var d = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num4,
        453,
        231,
        '4.5.3 体育场地设施建设情况',
        '',
        '',
        {
          code: 453,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 231,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
    },
    compare(attr) {
      return function(a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },
    arrayLookup(data, key, value, targetKey) {
      var targetValue = ''
      for (var i = 0; i < data.length; i++) {
        if (data[i][key] == value) {
          targetValue = data[i][targetKey]
          break
        }
      }
      return targetValue
    },
    handleValue0(x, y, z, a) {
      var isExit = false
      var obj = {}
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value6 = z.value6
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      var q = this.handleValueModle0(
        42101,
        42102,
        42103,
        42104,
        42105,
        42106,
        42107,
        42108, 0, 0,
        this.room_sum_area,
        421,
        186,
        '4.2.1 音体美卫功能教室合计',
        ' ',
        '个、m²',
        {
          code: 421,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 186,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '42101+42102+42103+42104+42105+42106+42107+42108'
      )
      this.room_sum_area = q

      var p = this.handleValueModle0(
        42201,
        42202,
        42203,
        42204,
        42205,
        42206,
        0,
        0, 0, 0,
        this.fuzhu_area,
        422,
        195,
        '4.2.2 配套辅助用房合计',
        ' ',
        '个、m²',
        {
          code: 422,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 195,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '42201+42202+42203+42204+42205+42206'
      )
      this.fuzhu_area = p

      var j = this.handleValueModle0(
        451,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.gym_averag,
        452,
        230,
        '4.5.2 生均体育场地面积',
        ' ',
        'm²',
        {
          code: 452,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 230,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '451/111'
      )
      this.gym_averag = j

      var i = this.handleValueModle0(
        45101,
        45102,
        45103,
        45104,
        45105,
        45106,
        45107,
        45108,
        45109,
        0,
        this.gym_area,
        451,
        220,
        '4.5.1 体育场地合计',
        '体育运动场馆面积是指学校中的体育馆和运动场地面积之和,运动场地面积是指学校专门用于室外体育运动并有相应设施所占用的土地面积',
        '个、m²',
        {
          code: 451,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 220,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '45101+45102+45103+45104+45105+45106+45107+45108+45109'
      )
      this.gym_area = i
    },
    handleValue(x, y, z, a) {
      var isExit = false
      var obj = {}
      obj.code = z.code
      obj.id = z.id
      obj.name = z.name
      obj.desc = z.desc
      obj.uom = z.uom
      obj.equipstandardopt = z.equipstandardopt
      obj.logic = z.logic
      obj.value1 = null
      obj.value2 = null
      obj.value3 = null
      obj.value4 = null
      obj.value5 = z.value5
      obj.value6 = null
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value5 = z.value5
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      console.log(this.form, 'this.form')

      var a = this.handleValueModle(
        42101,
        42102,
        42103,
        42104,
        42105,
        42106,
        42107,
        42108,
        0, 0,
        this.sum,
        421,
        186,
        '4.2.1 音体美卫功能教室合计',
        ' ',
        '个、m²',
        {
          code: 421,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 186,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '42101+42102+42103+42104+42105+42106+42107+42108'
      )
      this.sum = a

      var b = this.handleValueModle(
        42201,
        42202,
        42203,
        42204,
        42205,
        42206,
        0,
        0, 0, 0,
        this.fuzhu,
        422,
        195,
        '4.2.2 配套辅助用房合计',
        ' ',
        '个、m²',
        {
          code: 422,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 195,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '42201+42202+42203+42204+42205+42206'
      )
      this.fuzhu = b

      var c = this.handleValueModle(
        431,
        432,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.sheshi,
        43,
        202,
        '4.3 器材设备设施情况',
        ' ',
        '元 ',
        {
          code: 43,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 202,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '431+432'
      )
      this.sheshi = c

      var d = this.handleValueModle(
        43101,
        43102,
        43103,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.yiqi_yuanzhi,
        431,
        203,
        '4.3.1 仪器器材原值合计',
        '用于音、体、美教学的器材当时购买价格合计',
        '元 ',
        {
          code: 431,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 203,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '43101+43102+43103'
      )
      this.yiqi_yuanzhi = d

      var e = this.handleValueModle(
        43201,
        43202,
        43203,
        43204,
        43205,
        43206,
        0,
        0,
        0,
        0,
        this.equip_yuanzhi,
        432,
        207,
        '4.3.2 设备设施原值合计',
        '指功能室配备的桌、椅、仪器柜和水、电、光、气、安全等设施设备当时购买价格合计',
        '元 ',
        {
          code: 432,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 207,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '43201+43202+43203+43204+43205+43206'
      )
      this.equip_yuanzhi = e

      var f = this.handleValueModle(
        43,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.equip_price,
        433,
        214,
        '4.3.3 仪器设备生均金额',
        '',
        '元 ',
        {
          code: 433,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 214,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '43/111'
      )
      this.equip_price = f

      var g = this.handleValueModle(
        431,
        0,
        0,
        0,
        0,
        0,
        0,
        0, 0, 0,
        this.ytm_price,
        43301,
        215,
        '      其中：音体美生均金额',
        '',
        '元 ',
        {
          code: 43301,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 215,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '431/111'
      )
      this.ytm_price = g

      var h = this.handleValueModle(
        4401,
        4402,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.jf_sum,
        44,
        216,
        '4.4 当年功能室投入经费合计',
        ' ',
        '元 ',
        {
          code: 44,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 216,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '4401+4402'
      )
      this.jf_sum = h

      var i = this.handleValueModle(
        45101,
        45102,
        45103,
        45104,
        45105,
        45106,
        45107,
        45108,
        45109,
        0,
        this.gym,
        451,
        220,
        '4.5.1 体育场地合计',
        '体育运动场馆面积是指学校中的体育馆和运动场地面积之和,运动场地面积是指学校专门用于室外体育运动并有相应设施所占用的土地面积',
        '个、m²',
        {
          code: 451,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 220,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '45101+45102+45103+45104+45105+45106+45107+45108+45109'
      )
      this.gym = i


      if (this.form.length == this.data.length) {
        this.form.sort(this.compare('id'))
        this.toJson()
      }
    },
    handleValueModle0(
      code1,
      code2,
      code3,
      code4,
      code5,
      code6,
      code7,
      code8,
      code9, code10,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var pupil = this.arrayLookup(this.form, 'code', code1, 'value6')
      var junior = this.arrayLookup(this.form, 'code', code2, 'value6')
      var heigh = this.arrayLookup(this.form, 'code', code3, 'value6')
      var others = this.arrayLookup(this.form, 'code', code4, 'value6')
      var pupil1 = this.arrayLookup(this.form, 'code', code5, 'value6')
      var junior1 = this.arrayLookup(this.form, 'code', code6, 'value6')
      var heigh1 = this.arrayLookup(this.form, 'code', code7, 'value6')
      var heigh11 = this.arrayLookup(this.form, 'code', code8, 'value6')
      var pupil11 = this.arrayLookup(this.form, 'code', code9, 'value6')
      var junior11 = this.arrayLookup(this.form, 'code', code10, 'value6')
      value =
        Number(pupil) +
        Number(junior) +
        Number(heigh) +
        Number(others) +
        Number(pupil1) +
        Number(junior1) +
        Number(heigh1) +
        Number(heigh11) +
        Number(pupil11) +
        Number(junior11)
      if (code == 452) {
        var num2 = localStorage.getItem('111')
        var value1 = Number(pupil) / Number(num2)
        value = value1.toFixed(1)
      }

      if (value) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = null
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = null
        obj1.value6 = value
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value6 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    handleValueModle(
      code1,
      code2,
      code3,
      code4,
      code5,
      code6,
      code7,
      code8,
      code9,
      code10,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var pupil = this.arrayLookup(this.form, 'code', code1, 'value5')
      var junior = this.arrayLookup(this.form, 'code', code2, 'value5')
      var heigh = this.arrayLookup(this.form, 'code', code3, 'value5')
      var others = this.arrayLookup(this.form, 'code', code4, 'value5')
      var pupil1 = this.arrayLookup(this.form, 'code', code5, 'value5')
      var junior1 = this.arrayLookup(this.form, 'code', code6, 'value5')
      var heigh1 = this.arrayLookup(this.form, 'code', code7, 'value5')
      var others1 = this.arrayLookup(this.form, 'code', code8, 'value5')
      var pupil2 = this.arrayLookup(this.form, 'code', code9, 'value5')
      var junior2 = this.arrayLookup(this.form, 'code', code10, 'value5')
      value =
        Number(pupil) +
        Number(junior) +
        Number(heigh) +
        Number(others) +
        Number(pupil1) +
        Number(junior1) +
        Number(heigh1) +
        Number(others1) +
         Number(pupil2) +
        Number(junior2)
      if (code == 433 || code == 43301) {
        var num2 = localStorage.getItem('111')
        var value1 = Number(pupil) / Number(num2)
        value = value1.toFixed(1)
      }
      if (
        code == 41 ||
        code == 42 ||
        code == 45 ||
        code == 453
      ) {
        value = null
      }
      if (
        value ||
        code == 41 ||
        code == 42 ||
        code == 45 ||
        code == 453
      ) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = null
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = value
        obj1.value6 = null
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value5 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    toJson() {
      for (let i = 0; i < this.form.length; i++) {
        const id = this.form[i].id
        const code = this.form[i].code
        const name = this.form[i].name
        const desc = this.form[i].desc
        const uom = this.form[i].uom
        const equipstandardopt = this.form[i].equipstandardopt
        const logic = this.form[i].logic
        const value1 = null
        const value2 = null
        const value3 = null
        const value4 = null
        const value5 = this.form[i].value5
        const value6 = this.form[i].value6
        this.jsonForm[id] = {
          code,
          name,
          desc,
          uom,
          equipstandardopt,
          logic,
          value1,
          value2,
          value3,
          value4,
          value5,
          value6
        }
      }
    },
    handleClear() {
      this.$confirm('此操作将永久删除该表格数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          localStorage.removeItem('form4')
          this.$emit('clear')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleSave() {
      if (this.pushArr == true) {
        if (this.form.length < this.data.length) {
          this.$message.error('保存失败，请填写完整！')
        } else if ((this.form.length == this.data.length)) {
          this.toJson()
          const obj = {}
          obj.data = JSON.stringify(this.jsonForm)
          api.statistics.submit(obj).then((res) => {
            console.log(res)
            if (JSON.parse(localStorage.getItem('form4')) !== this.form) {
              this.$message.success('已保存成功！')
              localStorage.setItem('form4', JSON.stringify(this.form))
            } else if (JSON.parse(localStorage.getItem('form4')) == this.form) {
              this.$message.error('无修改数据！')
            } else {
              this.$message.success('已保存成功！')
              localStorage.setItem('form4', JSON.stringify(this.form))
            }
          })
        }
      } else {
        this.$message.error('保存失败，请仔细校验有取值逻辑的数值是否符合逻辑')
      }
    },
    handleName(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[\u4e00-\u9fa5]|[a-zA-Z]+$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入中英文')
        }
      }, 800)
    },
    handleNumber(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入数字')
        }
      }, 800)
    },
    handlePre() {
      this.$emit('pre')
    },
    handleNext() {
      if (this.form.length == this.data.length) {
        this.$emit('next')
      } else {
        this.$message.error('请先填写当前页面，才可进行下一步')
      }
    },
    handleOpen(v) {
      this.$alert(v, '查看指标解释', {
        confirmButtonText: '关闭',
        callback: (action) => {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.term3 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      .el-input {
        width: 62%;
      }
    }
    > span {
      padding: 0px 15px;
      border: 1px solid #d7d7d7;
      line-height: 34px;
      cursor: pointer;
      color: #8b8b8b;
    }
  }
  &-content {
    margin-top: 25px;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
    .logic {
      cursor: pointer;
    }
  }
}
.term3-top-info /deep/ .el-input__inner {
  height: 34px;
}
.text-center {
  display: block;
  text-align: center;
}
</style>
